import { People, Schedule } from "@mui/icons-material";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { update } from "../features/search/searchSlice";
import {
  useGetUserInfoQuery,
  useSearchSessionsQuery,
  useTagsQuery
} from "../services/api";

const SessionSearch = () => {
  const dispatch = useDispatch();
  const booked = useSelector((s: RootState) => s.search.booked);
  const previous = useSelector((s: RootState) => s.search.previous);
  const tag = useSelector((s: RootState) => s.search.tag);
  const watching = useSelector((s: RootState) => s.search.watching);
  const { data: user } = useGetUserInfoQuery();
  const { data: tags } = useTagsQuery();
  const { refetch } = useSearchSessionsQuery({
    booked,
    previous,
    tag,
    watching,
  });

  return (
    <Paper
      sx={{
        marginLeft: 2,
        padding: 2,
        marginRight: {
          xs: 2,
          md: 0,
        },
        md: {
          width: '100%',
        }
      }}
    >
      <Grid container spacing={2}>
        <Grid container item spacing={1} xs={6} md={12}>
          <Grid item xs={12}>
            <Typography
              fontSize={16}
              fontWeight={500}
            >My Sessions</Typography>
          </Grid>
          {user?.role === 'member' && <>
            <Grid item xs={12}>
              <Button
                color='secondary'
                fullWidth
                onClick={() => {
                  dispatch(
                    update({
                      booked: !booked,
                      previous: !booked ? previous : false,
                      watching: false,
                    })
                  )
                }}
                startIcon={<People />}
                variant={booked
                  ? 'contained'
                  : 'outlined'
                }
              >Booked</Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                color='secondary'
                fullWidth
                onClick={() => {
                  dispatch(
                    update({
                      booked: false,
                      previous: false,
                      watching: !watching,
                    })
                  )
                }}
                startIcon={<Schedule />}
                variant={watching
                  ? 'contained'
                  : 'outlined'
                }
              >Watchlist</Button>
            </Grid>
          </>}
          <Grid item xs={12}>
            <Button
              color='secondary'
              fullWidth
              onClick={() => {
                dispatch(
                  update({
                    previous: !previous,
                    booked: booked || !previous,
                    watching: false,
                  })
                )
              }}
              variant={previous
                ? 'contained'
                : 'outlined'
              }
            >Previous</Button>
          </Grid>
          {user?.role === 'practitioner' && <Grid item sx={{
            display: { md: 'none' },
            paddingTop: { xs: '16px !important', md: 0 }
          }} xs={12}>&nbsp;</Grid>}
        </Grid>
        <Grid container item spacing={1} xs={6} md={12}>
          <Grid item xs={12}>
            <Typography
              fontSize={16}
              fontWeight={500}
            >Search</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              size="small"
            >
              <InputLabel>Select Topic</InputLabel>
              <Select
                label='Select Topic'
                onChange={(_) => {
                  dispatch(
                    update({
                      tag: String(_.target.value) || undefined
                    })
                  )
                }}
                value={tag || ''}
              >
                {['', ...(tags || [])].map(option => (
                  <MenuItem
                    key={option || 'Any'}
                    value={option}
                  >{option || 'Any'}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            display='flex'
            item
            justifyContent='space-evenly'
            xs={12}
          >
            <Button
              onClick={() => {
                dispatch(
                  update({
                    booked: false,
                    watching: false,
                    previous: false,
                    tag: undefined,
                  })
                )
              }}
            >Reset</Button>
            <Button
              onClick={() => {
                refetch()
              }}
            >Refresh</Button>
          </Grid>
          {user?.role === 'member' && <Grid item sx={{
            display: { md: 'none' },
            paddingTop: { xs: '16px !important', md: 0 }
          }} xs={12}>&nbsp;</Grid>}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default SessionSearch;